import { useContext, useEffect, useMemo, useState } from 'react'
import { listToMap, listToTree, textIncludes, treeNodePath } from '@/utils/utils'
import { getProjectClosedTasks, getProjectTasks } from '@/services/task/task'
import { projectContext } from '@/layouts/MainLayout'
import { Task } from '@/services/task/task.model'

export const useFilterTaskTree = (taskList, taskFilters) => {
  const filterTaskTree = useMemo(() => {
    const { searchValue, levels, assignees, priorities, status } = taskFilters
    const list = taskList.filter((task) => levels.length === 0 || levels.includes(task.path?.length))
    const taskTree = listToTree(list)
    const filterTree = (item) => {
      const searchPass = !searchValue || textIncludes(item.name, searchValue)
      const assigneesPass = assignees.length === 0 || item.assignees.some((item) => assignees.includes(item.memberId))
      const prioritiesPass = priorities.length === 0 || priorities.includes(item.priority)
      const statusPass = status.length === 0 || status.includes(item.status)
      if (searchPass && assigneesPass && prioritiesPass && statusPass) {
        return true
      }
      return item.children?.some((childItem) => filterTree(childItem))
    }
    return taskTree.filter(filterTree)
  }, [taskList, taskFilters])

  return filterTaskTree
}

export const resolveTaskItem = (taskMap, task) => ({ ...task, path: treeNodePath(taskMap, task) })

export const useRequestTaskList = (taskType, onSuccess?) => {
  const { projectType, projectId } = useContext(projectContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [taskMeta, setTaskMeta] = useState<any>({})
  const [taskList, setTaskList] = useState<Task.Info[]>([])

  const loadTaskList = async () => {
    setLoading(true)
    let data: Task.Info[]
    let meta: any
    try {
      if (taskType === 'open') {
        const res = await getProjectTasks(projectType, projectId)
        data = res[0]
        meta = res[1]
      } else {
        data = await getProjectClosedTasks(projectType, projectId)
        meta = { closeCount: data.length }
      }
      const taskMap = listToMap(data)
      const items = data.map((item) => resolveTaskItem(taskMap, item)).sort((a, b) => a.order - b.order)
      setTaskMeta((origin) => ({ ...origin, ...meta }))
      setTaskList(items)
      onSuccess?.(items)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadTaskList()
  }, [taskType])

  return { loading, taskMeta, taskList, loadTaskList }
}
